import moment from 'moment';
import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    loading: true,
    lastFetch: null,
    forecast: {},
    hourlyForecasts: {},
    current: {},
    lowGDUsRisk: {},
    field: undefined,
};

export default createReducer(initial, {
    [actions.fetchWeather.request]: (state) => ({
        ...state,
        loading: true,
        forecast: {},
        current: {},
        hourlyForecasts: {},
    }),
    [actions.fetchWeather.failure]: () => initial,
    [actions.fetchWeather]: (_, action) => {
        // eslint-disable-line no-unused-vars
        if (action.payload.length === 0) return { ...initial, loading: false };
        const weather = action.payload.reduce(
            (weather, data) => {
                const lastFetch = moment().toISOString();
                if (data) {
                    const hourlyForecasts = data.hourlyForecasts.map((el) => ({
                        ...el,
                        data: [el.data],
                    }));
                    weather.current[data.field] = { id: data.id, ...data.current };
                    weather.current[data.field].lastFetch = lastFetch;
                    weather.forecast[data.field] = { id: data.id, dates: data.forecast };
                    weather.forecast[data.current.lastFetch] = lastFetch;
                    weather.hourlyForecasts[data.field] = { id: data.id, dates: hourlyForecasts };
                    weather.hourlyForecasts[data.current.lastFetch] = lastFetch;
                    weather.lowGDUsRisk[data.field] = { id: data.id, ...data.lowGDUsRisk };
                }
                weather.field = data.field;
                return weather;
            },
            {
                current: initial.current,
                forecast: initial.forecast,
                hourlyForecasts: initial.hourlyForecasts,
                lowGDUsRisk: initial.lowGDUsRisk,
            }
        );
        return { ...weather, loading: false };
    },
    [actions.setField]: (state, action) => {
        return { ...state, field: action.payload };
    },
});
